import { Component } from '@angular/core';

@Component({
  selector: 'emm-common-items-faq-dialog',
  templateUrl: './common-items-faq-dialog.component.html',
  styleUrl: './common-items-faq-dialog.component.scss'
})
export class CommonItemsFaqDialogComponent {
    faqs = [
        {
            question: 'Are common items just reusable trees?',
            answer: 'No, common items are more than just reusable trees. They include logic for context-aware ' +
                'variations, overrides, and consistent data management across EMM.'
        },
        {
            question: 'Do I need to copy-paste items from one spot to another?',
            answer: 'No, the purpose of common items is to eliminate the need for copying and pasting items. You can ' +
                'reference or assign the same common item in multiple places, maintaining a single source of truth.'
        },
        {
            question: 'What are common items and how is this different from current GMB and global items in Management?',
            answer: 'Common items are standardized items that can be reused across multiple contexts, streamlining ' +
                'management and ensuring consistency. Unlike current GMB and global items, which may be tied to specific' +
                ' modules or scopes, common items are designed for broader applicability and can be ' +
                'referenced in various places without duplication.'
        },
        {
            question: 'What do these mean? Variations (base vs non-base), overrides, context assignments, context properties',
            answer: 'A base variation is the default version of an item, while non-base variations are tailored for ' +
                'specific contexts. Overrides allow you to customize properties for certain uses without affecting ' +
                'the base item. Context assignments determine where and how a variation is applied, and context properties ' +
                'are additional data or settings specific to that usage.'
        },
        {
            question: 'How do I know all the differences in data for any given item?',
            answer: 'You can view a comparison of all variations of an item in the quick view. Differences are ' +
                'typically highlighted, allowing you to see what has been changed or overridden in each variation.'
        },
        {
            question: 'How do I know what makes this variation different?',
            answer: 'Within the variation details, you’ll see a breakdown of all components, overrides, and assignments ' +
                'with any differences from the base clearly indicated.'
        },
        {
            question: 'How do I know where this variation is used?',
            answer: 'The context assignments card shows where a variation is used when you expand the panel.'
        },
        {
            question: 'What happens if I edit the default base variation?',
            answer: 'Editing the base variation updates the default settings for all other variations, unless those' +
                ' properties have been specifically overridden elsewhere. Be cautious, as this can affect many ' +
                'places at once.'
        },
        {
            question: 'What happens if I edit the other variations besides the base?',
            answer: 'Editing a non-base variation only affects its specific context. Other variations and the base item' +
                ' remain unchanged, ensuring that context-specific customizations are isolated.'
        },
        {
            question: 'If I need to make a change, how do I know which variation to change?',
            answer: 'Consider whether the change should apply everywhere (edit the base) or only in a specific ' +
                'context (edit a context variation). Review the usage and impact before making changes.'
        },
        {
            question: 'How do I know which items are now using common items?',
            answer: 'Items that utilize common items will display a link icon next to them in Menu Viewer, Global Menu ' +
                'Builder, and Consumer Menu Assignment. In the New Menu Pilot section, you can edit these items'
        },
        {
            question: 'How can I make a change apply to other similar items in other places?',
            answer: 'Update the base variation or the common item itself. This ensures the change is propagated to all references unless a specific override is in place.'
        },
    ];
}
